(function () {
  var FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"]), [contenteditable="true"]';
  function fixSlide($slider) {
    $slider.find('.slick-slide[aria-hidden="true"]').find(FOCUSABLE).attr('tabindex', '-1');
    $slider.find('.slick-slide[aria-hidden="false"]').find(FOCUSABLE).removeAttr('tabindex');
  }
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof window.jQuery === 'undefined') return;
    window.jQuery(document).on('init.slick reInit.slick afterChange.slick', '.slick-slider', function () {
      fixSlide(window.jQuery(this));
    });
  });
})();
